import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'compressNumber'
})
export class CompressNumberPipe implements PipeTransform {

  transform(value: number): string {
    if (value === null || value === undefined) return '';

    const absValue = Math.abs(value);
    if (absValue < 1000) return value.toFixed(0).toString();

    const suffixes = ['', 'k', 'M', 'B'];
    const index = Math.floor(Math.log10(absValue) / 3);
    const compressedValue = (value / Math.pow(1000, index)).toFixed(0);
    return `${compressedValue.replace('.', ',')}${suffixes[index]}`;
  }
}
